module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Invoice Page"), _c('small', [_vm._v("This enhanced for printing "), _c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Invoice")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('section', {
    staticClass: "content invoice"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-xs-12 invoice-header"
  }, [_c('h2', {
    staticClass: "page-header"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Devin, Inc.\n                                "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("Date: 8/03/2017")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row invoice-info"
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-12 col-xs-12 invoice-col"
  }, [_vm._v(" From "), _c('address', [_c('strong', [_vm._v("Admin, Inc.")]), _vm._v(" "), _c('br'), _vm._v("795 Folsom Ave, Suite 600\n                                "), _c('br'), _vm._v("San Francisco, CA 94107\n                                "), _c('br'), _vm._v("Phone: (804) 123-5432\n                                "), _c('br'), _vm._v("Email: info@almasaeedstudio.com\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-sm-12 col-xs-12 invoice-col"
  }, [_vm._v(" To "), _c('address', [_c('strong', [_vm._v("John Doe")]), _vm._v(" "), _c('br'), _vm._v("795 Folsom Ave, Suite 600\n                                "), _c('br'), _vm._v("San Francisco, CA 94107\n                                "), _c('br'), _vm._v("Phone: (555) 539-1037\n                                "), _c('br'), _vm._v("Email: john.doe@example.com\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-sm-12 col-xs-12 invoice-col"
  }, [_c('b', [_vm._v("Invoice #007612")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Order ID:")]), _vm._v(" 4F3S8J\n                                "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Payment Due:")]), _vm._v(" 2/22/2017\n                                "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account:")]), _vm._v(" 968-34567 ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Qty")]), _vm._v(" "), _c('th', [_vm._v("Product")]), _vm._v(" "), _c('th', [_vm._v("Serial #")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Subtotal")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("Call of Duty")]), _vm._v(" "), _c('td', [_vm._v("455-981-221")]), _vm._v(" "), _c('td', [_vm._v("El snort testosterone trophy driving gloves handsome")]), _vm._v(" "), _c('td', [_vm._v("$64.50")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("Need for Speed IV")]), _vm._v(" "), _c('td', [_vm._v("247-925-726")]), _vm._v(" "), _c('td', [_vm._v("Wes Anderson umami biodiesel")]), _vm._v(" "), _c('td', [_vm._v("$50.00")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("Monsters DVD")]), _vm._v(" "), _c('td', [_vm._v("735-845-642")]), _vm._v(" "), _c('td', [_vm._v("Terry Richardson helvetica tousled street art master")]), _vm._v(" "), _c('td', [_vm._v("$10.70")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("Grown Ups Blue Ray")]), _vm._v(" "), _c('td', [_vm._v("422-568-642")]), _vm._v(" "), _c('td', [_vm._v("Tousled lomo letterpress")]), _vm._v(" "), _c('td', [_vm._v("$25.99")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-sm-12 col-xs-12 "
  }, [_c('p', {
    staticClass: "lead"
  }, [_vm._v("Payment Methods:")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/img/credit/visa.png",
      "alt": "Visa"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/img/credit/mastercard.png",
      "alt": "Mastercard"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/img/credit/american-express.png",
      "alt": "American Express"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/img/credit/paypal2.png",
      "alt": "Paypal"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted well well-sm no-shadow",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(" Etsy doostang zoodles disqus groupon greplin oooj voxy zoodles, weebly ning heekya handango imeem plugg dopplr jibjab, movity jajah plickers sifteo edmodo ifttt zimbra. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12 col-xs-12 "
  }, [_c('p', {
    staticClass: "lead"
  }, [_vm._v("Amount Due 2/22/2017")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Subtotal:")]), _vm._v(" "), _c('td', [_vm._v("$250.30")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Tax (9.3%)")]), _vm._v(" "), _c('td', [_vm._v("$10.34")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Shipping:")]), _vm._v(" "), _c('td', [_vm._v("$5.80")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Total:")]), _vm._v(" "), _c('td', [_vm._v("$265.24")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row no-print"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "onclick": "window.print();"
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right"
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Submit Payment")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "margin-right": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Generate PDF")])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56cf975c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/common-page/Invoice.vue
// module id = 1009
// module chunks = 2